import { setNavChildren } from 'logic/theme';
import { selectHasWorkoutSubscription } from 'logic/member';

export const Workouts = {
  template: `
    <div class="workouts bg-gray-100">
      <ui-view autoscroll="false"></ui-view>
      <upgrade ng-if="!$ctrl.hasAccess"></upgrade>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        this.setNavChildren('workouts');
      },

      $onDestroy() {
        this.disconnect();
        this.setNavChildren();
      },

      mapState({ member, router }) {
        return {
          hasAccess: selectHasWorkoutSubscription(member),
        };
      },

      mapDispatch() {
        return {
          setNavChildren,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Workouts.js